import type {StateCreator} from 'zustand'
import type {IssueComment} from '../../page-data/payloads/issue-comments'

export type CommentsPanelSlice = {
  issueComments: IssueComment[]

  commentsPanelActions: {
    setIssueComments: (comments: IssueComment[]) => void
    addIssueComment: (comment: IssueComment) => void
  }
}

export const createCommentsPanelSlice: StateCreator<
  CommentsPanelSlice,
  [['zustand/devtools', never]],
  [],
  CommentsPanelSlice
> = set => ({
  issueComments: [],

  commentsPanelActions: {
    setIssueComments: comments => {
      set({issueComments: comments}, undefined, 'setIssueComments')
    },

    addIssueComment: comment => {
      set(
        state => ({
          issueComments: [...state.issueComments, comment],
        }),
        undefined,
        'addIssueComment',
      )
    },
  },
})
